/*
 *
 * Product constants
 *
 */

export const GET_ALL_PRODUCT = 'w/Product/GET_ALL_PRODUCT';
export const GET_ALL_PRODUCT_SUCCESS = 'w/Product/GET_ALL_PRODUCT_SUCCESS';
export const GET_ALL_PRODUCT_FAILED = 'w/Product/GET_ALL_PRODUCT_FAILED';

export const GET_SINGLE_PRODDUCT = 'w/Product/GET_SINGLE_PRODDUCT';
export const GET_SINGLE_PRODDUCT_SUCCESS =
  'w/Product/GET_SINGLE_PRODDUCT_SUCCESS';
export const GET_SINGLE_PRODDUCT_FAILED =
  'w/Product/GET_SINGLE_PRODDUCT_FAILED';

export const GET_CLIENT_VARIANT_ALL = 'w/Product/GET_CLIENT_VARIANT_ALL';
export const GET_CLIENT_VARIANT_ALL_SUCCESS =
  'w/Product/GET_CLIENT_VARIANT_ALL_SUCCESS';
export const GET_CLIENT_VARIANT_ALL_FAILED =
  'w/Product/GET_CLIENT_VARIANT_ALL_FAILED';

export const GET_COLOR_OF_SIZE = 'w/Product/GET_COLOR_OF_SIZE';
export const GET_COLOR_OF_SIZE_SUCCESS = 'w/Product/GET_COLOR_OF_SIZE_SUCCESS';
export const GET_COLOR_OF_SIZE_FAILED = 'w/Product/GET_COLOR_OF_SIZE_FAILED';

export const CHANGE_COLOR_OF_ONE_SIZE = 'w/Product/CHANGE_COLOR_OF_ONE_SIZE';
export const CHANGE_COLOR_OF_ONE_SIZE_SUCCESS =
  'w/Product/CHANGE_COLOR_OF_ONE_SIZE_SUCCESS';
export const CHANGE_COLOR_OF_ONE_SIZE_FAILED =
  'w/Product/CHANGE_COLOR_OF_ONE_SIZE_FAILED';

export const ADD_TO_CART = 'w/Product/ADD_TO_CART';
export const ADD_TO_CART_SUCCESS = 'w/Product/ADD_TO_CART_SUCCESS';
export const ADD_TO_CART_FAILED = 'w/Product/ADD_TO_CART_FAILED';

export const DELETE_FROM_CART = 'w/Product/DELETE_FROM_CART';
export const DELETE_FROM_CART_SUCCESS = 'w/Product/DELETE_FROM_CART_SUCCESS';
export const DELETE_FROM_CART_FAILED = 'w/Product/DELETE_FROM_CART_FAILED';

export const PAYMENT_CART_SUCCESS = 'engage/Checkout/PAYMENT_CART_SUCCESS';
export const PAYMENT_CART_FAILED = 'engage/Checkout/PAYMENT_CART_FAILED';
